// extracted by mini-css-extract-plugin
module.exports = {"title":"ConfirmPhoneForm_title__RW8Kw","phoneInput":"ConfirmPhoneForm_phoneInput__aOlya","sendButton":"ConfirmPhoneForm_sendButton__MvzYe"};